export const multilingualOrderingField = (name: string) =>
  `${name}.langs[0].value`;
